import {useEffect, useState} from 'react';

function Completion(props) {
  const [ messageBody, setMessageBody ] = useState('');
  const [ paymentIntentID, setPaymentIntentID ] = useState('');
  const { stripePromise } = props;

  useEffect(() => {
    if (!stripePromise) return;

    stripePromise.then(async (stripe) => {
      const url = new URL(window.location);
      const clientSecret = url.searchParams.get('payment_intent_client_secret');
      const { error, paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);
      setPaymentIntentID(paymentIntent.id);
      setMessageBody(error ? `> ${error.message}` : (
        <>&gt; Payment {paymentIntent.status}: <a href={`https://dashboard.stripe.com/test/payments/${paymentIntent.id}`} target="_blank" rel="noreferrer">{paymentIntent.id}</a></>
      ));
    });
  }, [stripePromise]);

  return (
    <>
      <h1>Thank you!</h1>
      <h2>Your support genuinely means a lot to me. While my work was given out for free, you have chosen to set a value on my work higher than free.</h2>
      <p>Here is your payment ID, keep it! I might end up doing stuff for people who have donated!</p>
      <p style={{fontFamily: "monospace", textAlign: 'center', backgroundColor: "#1a1a1a", borderRadius: "10px"}}>{paymentIntentID}</p>
    </>
  );
}

export default Completion;
